define('view/layout/MainLayout',['require','__original__/MainLayout','lib/ExtendClassProperty','pwa/view/module/menu/MenuClientDataView'],function (require) {

    var ParentMainLayout = require('__original__/MainLayout');
    var extendProperty = require('lib/ExtendClassProperty');
    var MenuClientDataView = require('pwa/view/module/menu/MenuClientDataView');

    return ParentMainLayout.extend({

        regions: extendProperty('regions', {
            networkStatus: '#sb_network_status',
            menuClientData: '#menu_client_data',
        }),

        _clientModel: null,

        initialize: function () {
            ParentMainLayout.prototype.initialize.apply(this);

            this._clientModel = this.getOption('clientModel');
        },

        onBeforeShow: function () {
            this.showChildView('menuClientData', new MenuClientDataView({
                model: this._clientModel,
            }));
        },

        getNetworkStatusRegion: function () {
            return this.networkStatus;
        },

    });

});
